export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9830.759057e0.jpg";